"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAction = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const react_intl_1 = require("react-intl");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const interface_1 = require("../interface");
const ListAction = props => {
    const { buttonVariant = "secondary", buttonSize = "medium", className, dataTestId, disabled, icon: Icon, message, messageValues = {}, loadingComponent, onClick, variant = interface_1.ListActionVariant.iconButton, } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const onClickHandler = (event) => {
        event.preventDefault();
        void onClick?.();
    };
    switch (variant) {
        case interface_1.ListActionVariant.button:
            return ((0, jsx_runtime_1.jsx)(ui_kit_1.Button, { className: className, size: buttonSize, intent: buttonVariant, onClick: onClickHandler, disabled: disabled, startIcon: Icon ? (0, jsx_runtime_1.jsx)(Icon, {}) : null, "data-testid": dataTestId, children: loadingComponent ? loadingComponent : (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: message, values: messageValues }) }));
        case interface_1.ListActionVariant.menuItem:
            return ((0, jsx_runtime_1.jsxs)(ui_kit_1.Menu.Item, { onClick: onClickHandler, disabled: disabled, "data-testid": dataTestId, children: [Icon ? ((0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemIcon, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })) : null, (0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { variant: "inherit", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: message, values: messageValues }) })] }));
        case interface_1.ListActionVariant.iconButton:
        default:
            return ((0, jsx_runtime_1.jsx)(ui_kit_1.Tooltip, { title: formatMessage({ id: message }, { ...messageValues }), children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", onClick: onClickHandler, disabled: disabled, "data-testid": dataTestId, children: Icon ? (0, jsx_runtime_1.jsx)(Icon, {}) : (0, jsx_runtime_1.jsx)(Warning_1.default, {}) }) }));
    }
};
exports.ListAction = ListAction;
//# sourceMappingURL=index.js.map